import Vue from 'vue'
import Router from 'vue-router'
//import Login from '@/views/Home.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      //name: 'home',
      meta: {
        breadCrumb: 'Home',
        breadCrumbPaths:['/'],
        enabledByPermission: false,
        isMenuItem: false,
        module: 'portal',
        action: 'getuser'
      },
      component: () => import('@/views/Home.vue'),
      children: [
        {
          path: '',
          disabled: 'disabled',
          name: 'home',
          text: 'Home',
          icon: 'fa-home',
          localAction: true,
          meta: {
            breadCrumb: 'Home',
            breadCrumbPaths:[''],
            isMenuItem: false,
            enabledByPermission: false,
            module: 'portal',
            action: 'getnotifications'
          },
          component: () => import('@/views/Dashboard.vue')
        },
        {
          path: '/notificacoes',
          name: 'notificacoes',
          text: 'Notificações',
          icon: 'far fa-bell',
          meta: {
            isMenuItem: false,
            breadCrumb: 'Home/Notificações',
            breadCrumbPaths: ['/','notificacoes'],
            enabledByPermission: true,
            module: 'portal',
            action: 'getnotifications'
          },
          component: () => import('@/views/Notifications.vue')
        },
        {
          path: '/autorizacao',
          name: 'autorizacao',
          text: 'Autorização',
          icon: 'mdi-format-list-bulleted',
          module: 'autorizador',
          redirect:'/autorizacao/dashboarddemonitoramento',
          meta: {
            breadCrumb: 'Home/Autorizacao',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'autorizador',
            action: null
          },
          component: () => import('@/views/Autorizador.vue'),
          children: [{
            path: '/autorizacao/dashboarddemonitoramento',
            name: 'dashboardmonitoring',
            text: 'Dashboard de monitoramento',
            meta: {
              breadCrumb: 'Home/Autorização/Dashboard de monitoramento',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'autorizador',
              action: 'getmonitoramento'
            },
            component: () => import('@/components/autorizador/DashboardDeMonitoramento.vue'),
          },
          {
            path: '/autorizacao/visaoanalitica',
            name: 'visaoanalitica',
            text: 'Visão Analítica',
            meta: {
              breadCrumb: 'Home/Autorização/Visão Analítica',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'autorizador',
              action: 'getgraficocomparativo'
            },
            component: () => import('../components/autorizador/VisaoAnalitica.vue'),
          },
          {
            path: '/autorizacao/extratodeautorizacao',
            name: 'extratodeautorizacao',
            text: 'Extrato de Autorizações',
            meta: {
              breadCrumb: 'Home/Autorização/Extrato de Autorizações',
              isMenuItem: true,
              enabledByPermission: false,
              module: 'autorizador',
              action: 'getextratosolicitacoes'
            },
            component: () => import('@/components/autorizador/ExtratoDeSolicitacao.vue')
          },
          {
            path: '/autorizacao/extratodetransacao',
            name: 'extratodetransacao',
            text: 'Extrato de Transações',
            meta: {
              breadCrumb: 'Home/Autorização/Extrato de Transações',
              isMenuItem: true,
              enabledByPermission: false,
              module: 'autorizador',
              action: 'getextratotransacoes'
            },
            component: () => import('@/components/autorizador/ExtratoDeTransacao.vue')
          }]
        },
        {
          path: '/faturamento',
          name: 'faturamento',
          text: 'Faturamento',
          icon: 'fa-file-invoice-dollar',
          redirect: '/faturamento/monitordeatividades',
          meta: {
            breadCrumb: 'Home/Faturamento',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'faturamento',
            action: null,
          },
          component: () => import('@/views/Faturamento.vue'),
          children: [{
            path: '/faturamento/agendacronogramas',
            // name: 'agendacronogramas',
            text: 'Agenda de cronogramas',
            meta: {
              breadCrumb: 'Home/Faturamento/Agenda de cronogramas',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'faturamento',
              action: null,
            },
            component: () => import('@/components/faturamento/Agenda.vue'),
            children: [{
              path: '',
              name: 'agendacronogramas',
              text: 'Agenda de cronogramas',
              meta: {
                breadCrumb: 'Home/Faturamento/Agenda de cronogramas',
                isMenuItem: false,
                enabledByPermission: true,
                module: 'faturamento',
                action: 'getagendacronograma',
                },
              component: () => import('@/components/faturamento/agenda/Agenda.vue')
              },{
                path: '/faturamento/agendacronogramas/novocronograma',
                name: 'novocronograma',
                text: 'Cadastro de Cronogramas',
                meta: {
                  breadCrumb: 'Home/Faturamento/Agenda de cronogramas/Novo Cronograma',
                  isMenuItem: false,
                  enabledByPermission: true,
                  module: 'faturamento',
                  action: 'addcronograma',
                },
                component: () => import('@/components/faturamento/CronogramaForm.vue')
              },{
                path: '/faturamento/agendacronogramas/gerenciarferiados',
                name: 'gerenciarferiados',
                text: 'Gerenciar Feriados',
                meta: {
                  breadCrumb: 'Home/Faturamento/Agenda de cronogramas/Gerenciar Feriados',
                  isMenuItem: false,
                  enabledByPermission: true,
                  module: 'faturamento',
                  action: 'addferiado',
                },
                component: () => import('@/components/faturamento/agenda/Feriados.vue')
              }]
          },{
            path: '/faturamento/cronogramas',
            // name: 'cronogramas',
            text: 'Cronogramas',
            meta: {
              breadCrumb: 'Home/Faturamento/Cronogramas',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'getcronogramas',
            },
            component: () => import('@/components/faturamento/Cronogramas.vue'),
            children: [{
              path: '',
              name: 'cronogramas',
              text: 'Cronogramas',
              meta: {
                breadCrumb: 'Home/Faturamento/Cronogramas',
                isMenuItem: false,
                enabledByPermission: true,
                module: 'faturamento',
                action: 'getcronogramas',
              },
              component: () => import('@/components/faturamento/Cronograma.vue')
            },{
              path: '/faturamento/cronogramas/novocronograma',
              name: 'cadastrocronogramas',
              text: 'Cadastro de Cronograma',
              meta: {
                breadCrumb: 'Home/Faturamento/Cronogramas/Novo Cronograma',
                isMenuItem: false,
                enabledByPermission: true,
                module: 'faturamento',
                action: 'addcronograma'
              },
              component: () => import('@/components/faturamento/CronogramaForm.vue')
            },{
              path: '/faturamento/cronogramas/cadastrocronograma/:id',
              name: 'cadastrocronogramas',
              text: 'Agenda de cronogramas',
              meta: {
                breadCrumb: 'Home/Faturamento/Cronogramas/Cadastro de Cronograma',
                isMenuItem: false,
                enabledByPermission: true,
                module: 'faturamento',
                action: 'updatecronograma'
              },
              component: () => import('@/components/faturamento/CronogramaForm.vue')
            },{
              path: '/faturamento/cronogramas/dadosdocronograma/:id',
              name: 'dadosdocronograma',
              text: 'Dados do Cronograma',
              meta: {
                breadCrumb: 'Home/Faturamento/Cronogramas/Dados do Cronograma',
                isMenuItem: false,
                enabledByPermission: true,
                module: 'faturamento',
                action: 'getdetalhescronograma',
              },
              component: () => import('@/components/faturamento/DadosCronograma.vue')
            },{
              path: '/faturamento/cronogramas/dadosdocronograma/detalhesdolote/:id',
              name: 'detalhesdolote',
              text: 'Detalhes do lote',
              meta: {
                breadCrumb: 'Home/Faturamento/Cronogramas/Dados do Cronograma/Detalhes do lote',
                isMenuItem: false,
                enabledByPermission: true,
                module: 'faturamento',
                action: 'getdetalheslote',
              },
              component: () => import('@/components/faturamento/DetalhesLote.vue')
            },]
          },{
            path: '/faturamento/monitordeatividades',
            name: 'monitordeatividades',
            text: 'Monitor de atividades',
            meta: {
              breadCrumb: 'Home/Faturamento/Monitor de atividades',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'getmonitorcronogramas',
            },
            component: () => import('@/components/faturamento/MonitorDeAtividades.vue')
          },{
            path: '/faturamento/lotessemcronograma',
            name: 'lotessemcronograma',
            text: 'Lotes sem cronograma',
            meta: {
              breadCrumb: 'Home/Faturamento/Lotes sem cronograma',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'getgruposlotesemcronograma',
            },
            component: () => import('@/components/faturamento/LotesSemCronograma.vue')
          },{
            path: '/faturamento/dashboarddefaturamento',
            name: 'dashboarddefaturamento',
            text: 'Dashboard de faturamento',
            meta: {
              breadCrumb: 'Home/Faturamento/Dashboard de faturamento',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'getevolucaofaturamento',
            },
            component: () => import('@/components/faturamento/DashboardFaturamento.vue')
          },{
            path: '/faturamento/lotespendentes',
            name: 'lotespendentes',
            text: 'Complemento de cronograma (Lote)',
            meta: {
              breadCrumb: 'Home/Faturamento/Complemento de cronograma (Lote)',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'getcronogramascomplementares'
            },
            component: () => import('@/components/recebiveis/LotesPendentes.vue'),
          }]
        },
        {
          path: '/recebiveis',
          name: 'recebiveis',
          text: 'Recebíveis',
          icon: 'fa-money-bill-alt',
          redirect:'/recebiveis/monitorderecebiveis',
          meta: {
            breadCrumb: 'Home/Recebíveis',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'recebiveis',
            action: null
          },
          component: () => import('@/views/Recebiveis.vue'),
          children: [{
            path: '/recebiveis/monitorderecebiveis',
            name: 'monitorderecebiveis',
            text: 'Monitor de recebíveis',
            meta: {
              breadCrumb: 'Home/Recebíveis/Monitor de recebíveis',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getdashboardpagamento',
              },
            component: () => import('@/components/recebiveis/DashboardDeRecebiveis.vue')
          },{
            path: '/recebiveis/processosdeidentificacaodepagamentos',
            name: 'processosdeidentificacaodepagamentos',
            text: 'Processos de ident. de pagamentos',
            meta: {
              breadCrumb: 'Home/Recebíveis/Processos de identificação de pagamentos',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getprocessosidentificacaopagamento'
            },
            component: () => import('@/components/recebiveis/IdentificacaoDePagamento.vue'),
          },{
            path: '/recebiveis/pagamentosemprocessamento',
            name: 'pagamentosemprocessamento',
            text: 'Pagamentos em processamento',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos em processamento',
              isMenuItem: true,
              enabledByPermission: false,
              module: 'recebiveis',
              action: 'getpagamentosprocessamento'
            },
            component: () => import('@/components/recebiveis/PagamentosEmProcessamento.vue')
          },
          // { //DashboardFinanceiro
          //   path: '/recebiveis/dashboardfinanceiro',
          //   name: 'dashboardfinanceiro',
          //   text: 'Dashboard Financeiro',
          //   meta: {
          //     breadCrumb: 'Home/Recebíveis/Dashboard Financeiro',
          //     isMenuItem: false,
          //     enabledByPermission: true,
          //     module: 'recebiveis',
          //     action: null
          //   },
          //   component: () => import('@/components/recebiveis/DashboardFinanceiro.vue'),
          // },
          {
            path: '/recebiveis/pagamentospublicados',
            name: 'pagamentospublicados',
            text: 'Pagamentos publicados',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos publicados',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getpagamentospublicados'
            },
            component: () => import('@/components/recebiveis/PagamentosPublicados.vue'),
          },{
            path: '/recebiveis/pagamentos',
            name: 'pagamentos',
            text: 'Pagamentos',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'conciliacao'
            },
            props: route => ({
              operadoraAnsId: route.query.operadoraAnsId,
              prestadorId: route.query.prestadorId,
              status: route.query.status,
              responsavel: route.query.responsavel,
              minDataPagamento: route.query.minDataPagamento,
              maxDataPagamento: route.query.maxDataPagamento,
              sla: route.query.sla,
              tabKey: route.query.tabKey
            }),
            component: () => import('@/components/recebiveis/ListaPagamentos.vue'),
          // },{
          //         path: '/recebiveis/pagamentosnovo',
          //         name: 'pagamentosnovo',
          //         text: 'Pagamentos Novo',
          //         meta: {
          //             breadCrumb: 'Home/Recebíveis/Pagamentos',
          //             isMenuItem: true,
          //             enabledByPermission: true,
          //             module: 'conciliacao'
          //           },
          //           beforeEnter() {
          //             const grupoEconomico = router.app.$store.state.permissions.grupoEconomico;
                      
          //             const baseUrl = process.env.VUE_APP_RECEBIVEIS_V2_BASE_URL;
          //             const url = grupoEconomico 
          //                 ? `${baseUrl}?grupoEconomico=${grupoEconomico}`
          //                 : baseUrl;
                      
          //             window.location.href = url;
          //         }
              }, {
            path: '/recebiveis/pagamentos/:pagamentoId/:pagamentoLoteId/conciliacao',
            name: 'conciliacao',
            text: 'Conciliação',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos/Pagamento/Lote/Conciliação',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis'
            },
            props: route => ({
              pagamentoId: route.params.pagamentoId,
              pagamentoLoteId: route.params.pagamentoLoteId,
              pagamentoGuiaId: route.query.guia
            }),
            component: () => import('@/components/recebiveis/Conciliacao.vue'),
          }, {
            path: '/recebiveis/pagamentospublicados/detalhespagamento/:id',
            name: 'detalhespagamento',
            text: 'Detalhes do pagamento',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos publicados/Detalhes do Pagamento',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getdetalhespagamentopublicado',
              },
            component: () => import('@/components/recebiveis/DadosPagamento.vue')
          },{
            path: '/recebiveis/monitordeglosa',
            name: 'monitordeglosa',
            text: 'Monitor de Recurso de Glosa',
            meta: {
              breadCrumb: 'Home/Recebíveis/Monitor de recurso de glosa',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getmonitorrecursoglosa'
            },
            component: () => import('@/components/recebiveis/MonitorDeGlosa.vue'),
          },{
            path: '/recebiveis/pagamentos/:pagamentoId',
            name: 'pagamento',
            text: 'Pagamento',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos/Pagamento',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getPagamentos'
            },
            props: true,
            component: () => import('@/components/recebiveis/Pagamento.vue'),
          }, {
            path: '/recebiveis/pagamentos/:pagamentoId/baixa',
            name: 'pagamentoBaixa',
            text: 'Baixa',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos/Pagamento/Baixa',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis',
            },
            props: true,
            component: () => import('@/components/recebiveis/PagamentoBaixa.vue')
          }, {
            path: '/recebiveis/pagamentos/:pagamentoId/resumo',
            name: 'pagamentoResumo',
            text: 'Resumo',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos/Pagamento/Resumo',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis',
            },
            props: true,
            component: () => import('@/components/recebiveis/ResumoPagamento.vue')
          }, {
            path: '/recebiveis/pagamentos/:pagamentoId/:loteId',
            name: 'pagamentoLote',
            text: 'Lote',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos/Pagamento/Lote',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getLotes'
            },
            props: true,
            component: () => import('@/components/recebiveis/PagamentoLote.vue'),
          },{
            path: '/recebiveis/pagamentos/:pagamentoId/:loteId/conciliacao-manual',
            name: 'conciliacaoManualPagamentoLote',
            text: 'Conciliação manual',
            meta: {
              breadCrumb: 'Home/Recebíveis/Pagamentos/Pagamento/ConciliacaoManual',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getLotes'
            },
            props: true,
            component: () => import('@/components/recebiveis/ConciliacaoManualPagamentoLote.vue'),
          },{
            path: '/recebiveis/recursosdeglosa',
            name: 'recursosdeglosa',
            text: 'Recursos de glosa',
            meta: {
              breadCrumb: 'Home/Recebíveis/Recursos de glosa',
              isMenuItem: true,
              enabledByPermission: false,
              module: 'recebiveis',
              action: 'getrecursosglosa'
            },
            component: () => import('@/components/recebiveis/RecursosDeGlosa.vue')
          },{
            path: '/recebiveis/recursosdeglosa/historicodeuploads',
            name: 'historicodeuploads',
            text: 'Monitor de Uploads de Recurso de Glosa',
            meta: {
              breadCrumb: 'Home/Recebíveis/Recursos de glosa/Histórico de uploads',
              isMenuItem: false,
              enabledByPermission: false,
              module: 'recebiveis',
              action: 'getdocumentosupload'
            },
            component: () => import('@/components/recebiveis/HistoricoDeUploads.vue'),
          },
          {
            path: '/recebiveis/recursosdeglosa/recursosdeglosaedicao/:id',
            name: 'recursosdeglosaedicao',
            text: 'Edição de Recurso de Glosa',
            meta: {
              breadCrumb: 'Home/Recebíveis/Recursos de glosa/Edição de recurso de glosa',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getrecursosglosa'
            },
            component: () => import('@/components/recebiveis/RecursosDeGlosaEdicao.vue'),
          // },{
          //   path: '/recebiveis/glosassemcarteira',
          //   name: 'glosassemcarteira',
          //   text: 'Glosas sem carteira',
          //   meta: {
          //     breadCrumb: 'Home/Recebíveis/Glosas sem carteira',
          //     isMenuItem: true,
          //     enabledByPermission: false,
          //     module: 'recebiveis',
          //     action: null
          //   },
          //   component: () => import('@/components/recebiveis/RecursosDeGlosasSemCarteira.vue')

          },{
            path: '/recebiveis/recursosdeglosa/acompanhamentodeenvio/:id',
            name: 'acompanhamentodeenvio',
            text: 'Acompanhamento De Envio',
            meta: {
              breadCrumb: 'Home/Recebíveis/Recursos de glosa/Acompanhamento De Envio',
              isMenuItem: false,
              enabledByPermission: false,
              module: 'recebiveis',
              action: 'getrecursosglosa'
            },
          component: () => import('@/components/recebiveis/AcompanhamentoDeEnvio.vue'),
          },
          {
            path: '/recebiveis/carteiras',
            name: 'carteiras',
            text: 'Gestão de carteiras',
            meta: {
              breadCrumb: 'Home/Recebíveis/Gestão de carteiras',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'carteira',
              action: 'updatecarteira'
            },
            component: () => import('@/components/recebiveis/Pagamentos.vue'),
            children: [{
              path: '',
              name: 'carteiras',
              text: 'Gestão de carteiras',
              meta: {
                breadCrumb: 'Home/Recebíveis/Carteiras',
                isMenuItem: true,
                enabledByPermission: true,
                module: 'carteira',
                action: 'updatecarteira'
              },
              component: () => import('@/components/recebiveis/Carteiras.vue')
            },{
              path: '/recebiveis/carteiras/edicaocarteira/:id',
              name: 'edicaocarteira',
              text: 'Edição de carteira',
              meta: {
                breadCrumb: 'Home/Recebíveis/Carteiras/Edição de carteira',
                isMenuItem: false,
                enabledByPermission: false,
                module: 'carteira',
                action:  'updatecarteira'
                },
              component: () => import('@/components/recebiveis/DadosPagamento.vue')
            }]
          },
          {
            path: '/recebiveis/relatorios',
            name: 'relatorios',
            text: 'Relatórios',
            showSubmenu: true,
            meta: {
              breadCrumb: 'Home/Recebíveis/Relatórios',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getconsultapagamentos'
            },
            component: () => import('@/components/recebiveis/Pagamentos.vue'),
            children: [{
              path: '/recebiveis/consultadepagamentos',
              name: 'consultadepagamentos',
              text: 'Consulta de pagamentos',
              meta: {
                breadCrumb: 'Home/Recebíveis/Relatórios',
                isMenuItem: true,
                enabledByPermission: true,
                module: 'recebiveis',
                action: 'getconsultapagamentos'
              },
              component: () => import('@/components/recebiveis/PagamentosConsulta.vue')
            },{
                path: '/recebiveis/consultadepagamentosquitados',
                name: 'pagamentosquitados',
                text: 'Consulta de pagamentos quitados',
                meta: {
                  breadCrumb: 'Home/Recebíveis/Relatórios/Consulta de Pagamentos Quitados',
                  isMenuItem: true,
                  enabledByPermission: true,
                  module: 'recebiveis',
                  action: 'getpagamentosquitados',
                  },
                component: () => import('@/components/recebiveis/PagamentosQuitados.vue')
              },{
                path: '/recebiveis/relatorios/evolucaodofaturamento',
                name: 'evolucaodofaturamento',
                text: 'Evolução do faturamento',
                meta: {
                  breadCrumb: 'Home/Recebíveis/Relatórios/Evolução do faturamento',
                  isMenuItem: true,
                  enabledByPermission: false,
                  module: 'recebiveis',
                  action: null,
                  },
                component: () => import('@/components/recebiveis/EvolucaoFaturamento.vue')
              },{
                path: '/recebiveis/relatorios/extratoglosas',
                name: 'extratoglosas',
                text: 'Extrato de Glosas',
                meta: {
                  breadCrumb: 'Home/Recebíveis/Relatórios/Extrato de Glosas',
                  isMenuItem: true,
                  enabledByPermission: false,
                  module: 'recebiveis',
                  action: null,
                  },
                component: () => import('@/components/recebiveis/ExtratoGlosas.vue')
              },{
                path: '/recebiveis/relatorios/analiticofaturamento',
               name: 'analiticofaturamento',
                text: 'Relatório Analítico de Faturamento',
                meta: {
                  breadCrumb: 'Home/Recebíveis/Relatórios/Analítico de Faturamento',
                  isMenuItem: true,
                  enabledByPermission: false, // precisa adicionar permissão
                  module: 'recebiveis',
                  action: 'getanaliticofaturamento'
                  },
                component: () => import('@/components/recebiveis/AnaliticoFaturamento.vue')
              },{
                path: '/recebiveis/relatorios/analiticopagamentos',
                name: 'analiticopagamentos',
                text: 'Relatório Analítico de Pagamentos',
                meta: {
                  breadCrumb: 'Home/Recebíveis/Relatórios/Analítico de Pagamentos',
                  isMenuItem: true,
                  enabledByPermission: true,
                  module: 'recebiveis',
                  action: 'getanaliticopagamentos'
                  },
                component: () => import('@/components/recebiveis/AnaliticoPagamentos.vue')
              },{
                path: '/recebiveis/relatorios/envioanexofaturamento',
                name: 'envioanexofaturamento',
                text: 'Envio de Anexo do Faturamento',
                meta: {
                  breadCrumb: 'Home/Recebíveis/Relatórios/Extrato de Envio de Anexo do Faturamento',
                  isMenuItem: true,
                  enabledByPermission: true,
                  module: 'recebiveis',
                  action: 'getextratofatenvioanexo'
                  },
                component: () => import('@/components/recebiveis/ExtratoEnvioAnexoFaturamento.vue')
              }]
          },{
            path: '/recebiveis/lotespendentes',
            name: 'lotespendentes',
            text: 'Complemento de cronograma (Lote)',
            meta: {
              breadCrumb: 'Home/Recebíveis/Complemento de cronograma (Lote)',
              isMenuItem: true,
              enabledByPermission: true,
              module: 'recebiveis',
              action: 'getcronogramascomplementares'
            },
            component: () => import('@/components/recebiveis/LotesPendentes.vue'),
          },{
            path: '/recebiveis/lotespendentes/novocronograma',
            name: 'novocronograma',
            text: 'Cadastro de Cronogramas',
            meta: {
              breadCrumb: 'Home/Recebíveis/Complemento de cronograma (Lote)/Novo Cronograma',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'addcronograma',
            },
            component: () => import('@/components/faturamento/CronogramaForm.vue')
          },{
            path: '/recebiveis/lotespendentes/editarcronograma/:id',
            name: 'editarcronograma',
            text: 'Cadastro de Cronogramas',
            meta: {
              breadCrumb: 'Home/Recebíveis/Complemento de cronograma (Lote)/Editar Cronograma',
              isMenuItem: false,
              enabledByPermission: true,
              module: 'faturamento',
              action: 'updatecronograma',
            },
            component: () => import('@/components/faturamento/CronogramaForm.vue')
          }],
        },
        {
          path: '/documentos',
          name: 'files',
          text: 'Documentos',
          icon: 'far fa-file',
          meta: {
            breadCrumb: 'Home/Documentos',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'portal',
            action: 'getdocuments',
          },
          component: () => import('@/views/Documents.vue')
        },
        {
          path: '/identificacaonaoperadora',
          name: 'identificacaonaoperadora',
          text: 'Identificação na operadora',
          icon: 'fas fa-key',
          meta: {
            breadCrumb: 'Home/Identificação na operadora',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'recebiveis',
            action: 'getidentificacaooperadora',
          },
          component: () => import('@/views/IdentificacaoOperadora.vue'),
        },
        // {
        //   path: '/metabaseteste',
        //   name: 'metabaseteste',
        //   text: 'Metabase',
        //   icon: 'far fa-chart-bar',
        //   meta: {
        //     breadCrumb: 'Home/Metabase',
        //     isMenuItem: true,
        //     enabledByPermission: false,
        //     module: 'recebiveis',
        //     action: null
        //   },
        //   component: () => import('@/components/metabase/MetabaseTeste.vue')
        // },
        {
          path: '/redefinirsenha',
          name: 'redefinirSenha',
          text: 'Redefinir Senha',
          meta: {
            breadCrumb: 'Home/Redefinir Senha',
            isMenuItem: false,
            enabledByPermission: false,
            module: 'portal',
            action: 'changepassword',
          },
          component: () => import('@/views/ChangePassword.vue')
        },
      ]
    },
    {
      path: '/configuracoes',
      name: 'help',
      meta: {breadCrumb: 'Home'},
      component: () => import('@/views/Home.vue'),
      children: [
        {
          path: '/usuarios',
          name: 'users',
          text: 'Configurações',
          icon: 'fa-cog',
          meta: {
            breadCrumb: 'Home/Usuarios',
            isMenuItem: false,
            enabledByPermission: true,
            module: 'portal',
            action: 'getusers',
          },
          component: () => import('@/views/Users.vue')
        },
      ]
    },
    {
      path: '/',
      name: 'home',
      meta: {breadCrumb: 'Home'},
      component: () => import('@/views/Home.vue'),
      children: [
        {
          path: '/suporte',
          name: 'supportrequest',
          text1: 'Fale Conosco',
          meta: {
            breadCrumb: 'Home/Ajuda',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'portal',
            action: 'sendemail'
          },
          component: () => import('@/views/SupportRequest.vue')
        },
        {
          path: '/mudarsenha',
          name: 'mudarsenharequest',
          text1: 'Alterar Senha',
          meta: {
            breadCrumb: 'Home/mudarsenha',
            isMenuItem: true,
            enabledByPermission: true,
            module: 'portal',
            action: 'changepassword'
          },
          component: () => import('@/views/ChangePassword.vue')
          //component: () => import('@/views/ChangePasswordIntern.vue')
        },
        // {
        //   path: '/securitypolicy',
        //   name: 'securitypolicy',
        //   text2: 'Política de segurança',
        //   meta: {
        //     breadCrumb: 'Home/Legal',
        //     isMenuItem: true,
        //     enabledByPermission: false,
        //     module: 'portal',
        //     action: null
        //   },
        //   component: () => import('@/views/SecurityPolicy.vue')
        // }
      ]
    },
    {
      path: '*',
      redirect: '/'
    },
  ],
  scrollBehavior(to) {
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash })
        }, 300)
      })
    }
  },
})

router.beforeEach(async (to, from, next) => {
  const grupoEconomicoFromQuery = to.query.grupoEconomico;
  
  if (grupoEconomicoFromQuery && router.app && router.app.$store) {
    const grupoEconomicoId = parseInt(grupoEconomicoFromQuery);
    
    if (!isNaN(grupoEconomicoId) && grupoEconomicoId > 0) {
      try {
        const userData = router.app.$store.state.userData.userData;
        
        if (userData && userData.UsuarioTradimus) {
          const currentGrupoEconomico = router.app.$store.state.permissions.grupoEconomico;
          
          if (grupoEconomicoId !== currentGrupoEconomico) {
            console.log('Interceptando mudança de grupo econômico via navegação:', grupoEconomicoId);
            
            const grupoEconomicoList = router.app.$store.state.permissions.grupoEconomicoList;
            
            if (!grupoEconomicoList || !grupoEconomicoList.some(geco => geco.grupo_id === grupoEconomicoId)) {
              console.warn('Acesso negado: Usuário não tem permissão para acessar o grupo econômico', grupoEconomicoId);
              
              const newQuery = { ...to.query };
              delete newQuery.grupoEconomico;
              
              next({
                path: to.path,
                query: newQuery,
                params: to.params,
                replace: true
              });
              return;
            }
            
            await router.app.$store.dispatch('permissions/changeGrupoEconomico', grupoEconomicoId);
            
            const newQuery = { ...to.query };
            delete newQuery.grupoEconomico;
            
            next({
              path: to.path,
              query: newQuery,
              params: to.params,
              replace: true
            });
            return;
          }
        }
      } catch (error) {
        console.error('Erro ao processar mudança de grupo econômico via navegação:', error);
      }
    }
  }
  
  next();
});

export default router
